import { Box, Typography } from "@mui/material";
import { colors, radii, shadows, fonts } from "../../../theme/designTokens";

// A visually distinct, boxed section within the Add/Edit Medicine forms
// (Media, Identification, Variations, SEO, Additional Section), replacing
// the flat "disabled button as a label" convention those forms used.
export default function MedicineFormSection({ icon, title, action, children }) {
  return (
    <Box
      sx={{
        bgcolor: colors.white,
        border: `1px solid ${colors.line}`,
        borderRadius: radii.lg,
        boxShadow: shadows.card,
        p: { xs: 2, sm: 3 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1,
          mb: 2.5,
          pb: 1.5,
          borderBottom: `1px solid ${colors.line}`,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
          {icon && (
            <Box
              sx={{
                width: 34,
                height: 34,
                borderRadius: radii.md,
                bgcolor: colors.primaryLight,
                color: colors.primary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              {icon}
            </Box>
          )}
          <Typography
            sx={{
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: 16,
              color: colors.ink,
            }}
          >
            {title}
          </Typography>
        </Box>
        {action}
      </Box>
      {children}
    </Box>
  );
}
